import { Link } from 'react-router-dom';

const Auth = () => {
  const handleLogin = (e) => {
    e.preventDefault();
    alert('登录成功（仅演示）');
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
      <div style={{ width: 400, backgroundColor: '#fff', padding: 24, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <h1 style={{ color: '#2d30e1ff', textAlign: 'center', marginBottom: 24 }}>FIFA博客登录</h1>
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 8, color: '#333' }}>用户名</label>
            <input 
              type="text" 
              required
              style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 4 }}
              placeholder="请输入用户名"
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 8, color: '#333' }}>密码</label>
            <input 
              type="password" 
              required
              style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 4 }}
              placeholder="请输入密码"
            />
          </div>
          <button 
            type="submit"
            style={{ 
              width: '100%',
              backgroundColor: '#2d57e1ff', 
              color: '#fff', 
              border: 'none', 
              padding: '8px 16px', 
              borderRadius: 4, 
              cursor: 'pointer' 
            }}
          >
            登录
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 16 }}>
          <Link to="/" style={{ color: '#2d54e1ff', textDecoration: 'none' }}>还没有账号？先去逛逛</Link>
        </p>
      </div>
    </div>
  );
};

export default Auth;